import React from "react";

import styled from "styled-components/macro";

import FnrButton3 from "UI/FnrButton3";

export default function PaymentDrawerError() {
  return (
    <Wrapper>
      <ErrorIcon className="fas fa-exclamation-triangle" />
      <p>Hmm. Something went wrong connecting to checkout.</p>
      <p>Please reload this page and try again.</p>
      <FnrButton3 onClick={() => window.location.reload()} color="blue">
        <ReloadIcon className="far fa-sync-alt" />
        Reload
      </FnrButton3>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 32px;
  font-weight: 400;
  gap: 24px;

  p {
    margin: 0;
  }
`;

const ReloadIcon = styled.i`
  margin-right: 8px;
  font-size: 0.9rem;
`;

const ErrorIcon = styled.i`
  font-size: 2rem;
  align-self: center;
  color: burlywood;
`;
